import { observer } from 'mobx-react-lite';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Alert,
  List,
  ListItem,
  ListItemText,
  Chip,
  Stack,
} from '@mui/material';
import { useManagerTeam } from './ManagerTeamPage';

export const ManagerTeamOverview = observer(() => {
  const { detail } = useManagerTeam();
  if (!detail) return null;

  const { team, master_user, members } = detail;

  return (
    <Stack spacing={3}>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Team
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
            <Chip
              label={team.is_billing ? 'Billing active' : 'Billing off'}
              size="small"
              color={team.is_billing ? 'success' : 'default'}
            />
            <Chip label={`${team.member_count} members`} size="small" />
          </Box>
          <Typography variant="body2" color="text.secondary">
            Billing owner: {master_user?.name || team.master_user_name || '—'}
            {master_user?.email ? ` (${master_user.email})` : ''}
          </Typography>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Members ({members.length})
          </Typography>
          {members.length === 0 ? (
            <Alert severity="info">No members on this team.</Alert>
          ) : (
            <List dense disablePadding>
              {members.map((m) => (
                <ListItem key={m.key} disableGutters>
                  <ListItemText primary={m.name} secondary={m.email} />
                </ListItem>
              ))}
            </List>
          )}
        </CardContent>
      </Card>
    </Stack>
  );
});
